import * as mapboxgl from 'mapbox-gl'
import * as React from 'react'

export type Registerable = mapboxgl.Marker | mapboxgl.Popup

export type Setup = (context: { map: mapboxgl.Map; marker?: mapboxgl.Marker }) => { id: string; value: Registerable }

type MapContext = {
  registered: Map<string, Registerable>
  push: (callback: Setup) => void
  pop: (id: string) => void
}

const mapContext = React.createContext<MapContext | undefined>(undefined)

export function useMapContext() {
  const context = React.useContext(mapContext)
  if (context === undefined) {
    throw Error('useMapContext must be used inside a <Map> element')
  }
  return context
}

type MapContextProvider = {
  value: MapContext
  children?: React.ReactNode
}

export function MapContextProvider({ value, children }: MapContextProvider) {
  return <mapContext.Provider value={value}>{children}</mapContext.Provider>
}
